/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNewspaper = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 2v6h4v11a3 3 0 0 1-3 3H2V2zm2 8h-2v9c0 .512.387.935.883.993L19 20a1 1 0 0 0 1-1zm-4-6H4v16h12.17l-.008-.026-.04-.122a2.964 2.964 0 0 1-.117-.676l.019.205A3.026 3.026 0 0 1 16 19zm-2 13v2H6v-2zm0-4v2H6v-2zm0-8v6H6V5zm-2 2H8v2h4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgNewspaper as Newspaper };
